import React from "react";
import ReactTooltip from "react-tooltip";

/**
 * Wrapper for Tooltip just for no-repeat classes and options
 * @param props
 */
const Tooltip = (props: any) => {
  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return <ReactTooltip effect="solid" offset={{ top: -5, left: 0 }} className="meeters-tooltip" />;
};

export default Tooltip;
